import {BATCH_SCHEMA_DEACTIVATED_PURPOSE} from 'archive/ArchiveConstants';
import {getArchivePurpose} from 'archive/ArchivePurposesUtil';
import isArchived from 'archive/isArchived';
import {BatchSchema} from 'constants/SampleConstants';

export default function isBatchSchemaDeactivated(batchSchema: BatchSchema | null): boolean {
  return (
    batchSchema != null &&
    isArchived(batchSchema) &&
    getArchivePurpose(batchSchema) === BATCH_SCHEMA_DEACTIVATED_PURPOSE
  );
}
